// Convert dbValues into a gain multiplier

src := """
const {pow} = Math;

class DBToGain extends AudioWorkletProcessor {
  process (inputs, outputs, parameters) {
    if (!inputs.length) {
      return false
    }

    const output = outputs[0]
    const input = inputs[0]

    output.forEach((channel, c) => {
      const cin = input[c];
      const l = channel.length;
      for (let i = 0; i < l; i++) {
        const v = cin ? cin[i] : 0;
        channel[i] = pow(10, v/20)
      }
    })
    return true
  }
}

registerProcessor('dbToGain', DBToGain)
"""

blob := new Blob [src], type: "application/javascript"
url := URL.createObjectURL(blob)

/**
Convert dbValues into a gain multiplier.

```
dbValue  -> dbToGain
              v
source -> multiplier -> destination
```
*/

export DBWorklet :=
  createDBGainNode: (context: BaseAudioContext) ->
    dbToGain := new AudioWorkletNode(context, 'dbToGain')

    multiplier := context.createGain()
    multiplier.gain.value = 0

    dbToGain.connect multiplier.gain

    Object.assign multiplier,
      db: dbToGain
      cleanup: ->
        // Saw what appeared to be AudioWorklet nodes leaking when debugging
        // with Audion, maybe disconnecting them cleans them up?
        dbToGain.disconnect()
        multiplier.disconnect()

  prepareContext: (context: BaseAudioContext & {prepared?: Promise<void>}) ->
    return context.prepared if context.prepared

    if !context.audioWorklet?.addModule
      // Safari / Older browsers
      return context.prepared = Promise.resolve()

    context.prepared = context.audioWorklet.addModule(url)
    .catch (e) ->
      context.prepared = undefined
      throw e

  test: (context: BaseAudioContext) ->
    DBWorklet.prepareContext(context)
    .then ->
      t := context.currentTime

      // Constant source
      s := context.createConstantSource()
      s.offset.value = 100
      s.start(t)

      // Oscillate between 96dB and -96dB
      osc := context.createOscillator()
      oscValue := context.createGain()
      oscValue.gain.setValueAtTime(96, t)
      osc.start(t)
      osc.connect oscValue

      dbGainNode := DBWorklet.createDBGainNode(context)

      // Connect db multiplier and source signal
      oscValue.connect dbGainNode.db
      s.connect dbGainNode
      dbGainNode.connect context.destination

export default DBWorklet
